"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OurBrands = exports.loadTheme = exports.mixins = exports.notoFontFamily = exports.fontFamily = exports.FontWeights = void 0;
const styles_1 = require("@material-ui/core/styles");
const createMixins_1 = __importDefault(require("@material-ui/core/styles/createMixins"));
const createBreakpoints_1 = __importDefault(require("@material-ui/core/styles/createBreakpoints"));
const colors_1 = require("./themeParts/colors");
Object.defineProperty(exports, "OurBrands", { enumerable: true, get: function () { return colors_1.OurBrands; } });
const buildColorsByBrand_1 = require("./themeParts/buildColorsByBrand");
const breakpoints = (0, createBreakpoints_1.default)({});
var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["Regular"] = 400] = "Regular";
    FontWeights[FontWeights["Bold"] = 700] = "Bold";
    FontWeights[FontWeights["Black"] = 900] = "Black";
})(FontWeights || (exports.FontWeights = FontWeights = {}));
exports.fontFamily = [
    'Lato',
    'Noto Sans', // Noto Sans with coverage for Latin, Cyrillic, and Greek character sets. Covers the bulk of our sites languages.
    'Noto Sans SC', // Simplified Chinese for mainland China
    'Noto Sans TC', // Traditional Chinese for Taiwan
    'Noto Sans JP', // Noto Sans for Japanese
    'Noto Sans KR', // Noto Sans for Korea
    '-apple-system', // Targets MacOS default system font. User can change this and OS default has changed over the years.
    '"Helvetica Neue"', // Helvetica version bundled with some OSes. Globally popular among designers, overall proprietary so limited covers.
    '"Segoe UI"', // Default Microsoft systems font
    '"Apple Color Emoji"', // Apple's emoji set
    '"Segoe UI Emoji"', // Microsoft default emoji font set
    '"Segoe UI Symbol"', // Microsoft default font set for special symbols and characters
    'sans-serif', // If none of the above satisfy a character displayed or user doesn't have them installed use whatever san-serif font their system defaults to.
].join(',');
exports.notoFontFamily = [
    'Noto Sans', // Noto Sans with coverage for Latin, Cyrillic, and Greek character sets. Covers the bulk of our sites languages.
    'Noto Sans SC', // Simplified Chinese for mainland China
    'Noto Sans TC', // Traditional Chinese for Taiwan
    'Noto Sans JP', // Noto Sans for Japanese
    'Noto Sans KR', // Noto Sans for Korea
    '-apple-system', // Targets MacOS default system font. User can change this and OS default has changed over the years.
    '"Helvetica Neue"', // Helvetica version bundled with some OSes. Globally popular among designers, overall proprietary so limited covers.
    '"Segoe UI"', // Default Microsoft systems font
    '"Apple Color Emoji"', // Apple's emoji set
    '"Segoe UI Emoji"', // Microsoft default emoji font set
    '"Segoe UI Symbol"', // Microsoft default font set for special symbols and characters
    'sans-serif', // If none of the above satisfy a character displayed or user doesn't have them installed use whatever san-serif font their system defaults to.
].join(',');
const { breakpoints: customBreakpoint, spacing } = (0, styles_1.createTheme)();
exports.mixins = (0, createMixins_1.default)(customBreakpoint, spacing, {
    limitLines: (number = 3) => {
        return {
            display: '-webkit-box',
            '-webkit-line-clamp': `${number}`,
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    },
    noList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
});
const loadTheme = (brandStyles = colors_1.OurBrands.SigmaAldrich, makeNotoPrimaryFont = false) => {
    const generatedColorData = (0, buildColorsByBrand_1.buildColorsByBrand)(brandStyles);
    const Colors = generatedColorData.colors;
    const AccentColors = generatedColorData.accentColors;
    const fontFamilySet = makeNotoPrimaryFont ? exports.notoFontFamily : exports.fontFamily;
    const themeConfig = {
        palette: {
            action: {
                disabledBackground: Colors.Grey500,
                focus: Colors.PrimaryMain,
            },
            background: {
                default: Colors.White,
                grey: Colors.BackgroundGray,
                highlight: Colors.Highlight,
                blue: Colors.BackgroundBlue,
            },
            divider: Colors.Divider,
            error: {
                main: Colors.ErrorMain,
                light: Colors.ErrorLight,
            },
            grey: {
                '50': Colors.Grey50,
                '100': Colors.Grey100,
                '200': Colors.Grey200,
                '300': Colors.Grey300,
                '400': Colors.Grey400,
                '500': Colors.Grey500,
                '600': Colors.Grey600,
                '700': Colors.Grey700,
                '800': Colors.Grey800,
                '900': Colors.Grey900,
            },
            primary: {
                light: Colors.PrimaryLight,
                main: Colors.PrimaryMain,
                dark: Colors.PrimaryDark,
            },
            rich: {
                purple: AccentColors.RichPurple,
                blue: AccentColors.RichBlue,
                green: AccentColors.RichGreen,
                red: AccentColors.RichRed,
            },
            secondary: {
                light: Colors.SecondaryLight,
                main: Colors.SecondaryMain,
                dark: Colors.SecondaryDark,
            },
            sensitive: {
                pink: AccentColors.SensitivePink,
                blue: AccentColors.SensitiveBlue,
                green: AccentColors.SensitiveGreen,
                yellow: AccentColors.SensitiveYellow,
            },
            success: {
                main: Colors.SuccessMain,
                dark: Colors.SuccessDark,
                light: Colors.SuccessLight,
            },
            text: {
                primary: Colors.TextPrimary,
            },
            vibrant: {
                magenta: AccentColors.VibrantMagenta,
                cyan: AccentColors.VibrantCyan,
                green: AccentColors.VibrantGreen,
                yellow: AccentColors.VibrantYellow,
            },
            warning: {
                main: Colors.WarningMain,
                dark: Colors.WarningDark,
                light: Colors.WarningLight,
            },
            brand: {
                dark: Colors.BrandDark,
                light: Colors.BrandLight,
                main: Colors.BrandMain,
            },
            orange: Colors.Orange,
            tonalOffset: 0.1,
        },
        typography: {
            fontFamily: fontFamilySet,
            fontWeightRegular: FontWeights.Regular,
            fontWeightMedium: FontWeights.Bold,
            fontWeightBold: FontWeights.Black,
            h1: {
                fontSize: '1.75rem', // 28px. 28/16 = 1.75
                fontWeight: FontWeights.Black,
                lineHeight: 1.2,
                color: Colors.TextPrimary,
                letterSpacing: '0.42px',
            },
            h2: {
                fontSize: '1.25rem', // 20px. 20/16 = 1.25
                fontWeight: FontWeights.Black,
                lineHeight: 1.2,
                textTransform: 'uppercase',
                letterSpacing: '1.5px',
                color: Colors.TextPrimary,
            },
            h3: {
                fontSize: '1.125rem', // 18px. 20/18 = 1.125
                fontWeight: FontWeights.Black,
                lineHeight: 1.2,
                color: Colors.TextPrimary,
            },
            h4: {
                color: Colors.TextPrimary,
                fontWeight: FontWeights.Regular,
            },
            body1: {
                fontSize: '1rem',
                fontWeight: FontWeights.Regular,
                color: Colors.TextPrimary,
                lineHeight: 1.5,
            },
            body2: {
                fontSize: '0.875rem', // 14px. 14/16 = 0.875
                fontWeight: FontWeights.Regular,
                color: Colors.TextPrimary,
                lineHeight: 1.43,
            },
            caption: {
                fontSize: '0.75rem', // 12px. 12/16 = 0.75
                fontWeight: FontWeights.Black,
                color: Colors.TextPrimary,
                lineHeight: 0.9375,
            },
        },
        shape: {
            borderRadius: 5,
        },
        spacing: 4,
        shadows: [
            'none',
            '0px 1px 3px 0px rgba(0,0,0,0.0),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)',
            '0px 1px 5px 0px rgba(0,0,0,0.0),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
            '0px 1px 8px 0px rgba(0,0,0,0.0),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)',
            '0px 2px 4px -1px rgba(0,0,0,0.0),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
            '0px 3px 5px -1px rgba(0,0,0,0.0),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
            '0px 3px 5px -1px rgba(0,0,0,0.0),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
            '0px 4px 5px -2px rgba(0,0,0,0.0),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
            '0px 5px 5px -3px rgba(0,0,0,0.0),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
            '0px 5px 6px -3px rgba(0,0,0,0.0),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
            '0px 6px 6px -3px rgba(0,0,0,0.0),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
            '0px 6px 7px -4px rgba(0,0,0,0.0),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
            '0px 7px 8px -4px rgba(0,0,0,0.0),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
            '0px 7px 9px -4px rgba(0,0,0,0.0),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
            '0px 7px 8px -4px rgba(0,0,0,0.0),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
            '0px 8px 9px -5px rgba(0,0,0,0.0),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
            '0px 8px 10px -5px rgba(0,0,0,0.0),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
            '0px 8px 11px -5px rgba(0,0,0,0.0),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
            '0px 9px 11px -5px rgba(0,0,0,0.0),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
            '0px 9px 12px -6px rgba(0,0,0,0.0),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
            '0px 10px 13px -6px rgba(0,0,0,0.0),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
            '0px 10px 13px -6px rgba(0,0,0,0.0),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
            '0px 10px 14px -6px rgba(0,0,0,0.0),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
            '0px 11px 14px -7px rgba(0,0,0,0.0),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
            '0px 11px 15px -7px rgba(0,0,0,0.0),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
        ],
        props: {
            MuiButtonBase: {
                disableRipple: true,
            },
            MuiButton: {
                disableRipple: true,
            },
            MuiCheckbox: {
                disableRipple: true,
            },
            MuiLink: {
                underline: 'none',
            },
            MuiTab: {
                disableRipple: true,
            },
            MuiIconButton: {
                disableRipple: true,
            },
        },
        overrides: {
            MuiCssBaseline: {
                '@global': {
                    html: {
                        height: '100%',
                    },
                    body: {
                        height: '100%',
                    },
                    '#__next': {
                        height: '100%',
                    },
                    'h1, h2, h3, h4, h5, h6, p': {
                        margin: 0,
                    },
                    '.DraftEditor-root': {
                        '& h1, h2': {
                            color: Colors.SecondaryMain,
                        },
                        '& a': {
                            color: Colors.PrimaryMain,
                        },
                    },
                    a: {
                        color: Colors.PrimaryMain,
                        fontWeight: FontWeights.Black,
                        textDecoration: 'none',
                        '&:hover': {
                            color: Colors.PrimaryDark,
                        },
                    },
                    i: {
                        textStyle: 'italic',
                    },
                    em: {
                        textStyle: 'italic',
                    },
                    b: {
                        fontWeight: FontWeights.Bold,
                    },
                    strong: {
                        fontWeight: FontWeights.Bold,
                    },
                    small: {
                        fontSize: '0.75rem', // 12px. 12/16 = 0.75
                        lineHeight: 0.9375,
                    },
                    '.RichText_ContentBlock_text-align-right': {
                        textAlign: 'right',
                    },
                    '.RichText_ContentBlock_text-align-center': {
                        textAlign: 'center',
                    },
                    '.RichText_Image-center': {
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    },
                    '.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1': {
                        listStyleType: 'circle',
                    },
                    '.public-DraftStyleDefault-listLTR.public-DraftStyleDefault-depth1': {
                        marginLeft: '1.4em',
                    },
                },
            },
            MuiTab: {
                root: {
                    fontWeight: FontWeights.Bold,
                    '&.Mui-focusVisible': {
                        outline: 'revert',
                    },
                },
            },
            MuiContainer: {
                root: {
                    paddingLeft: 16,
                    paddingRight: 16,
                    [breakpoints.up('sm')]: {
                        paddingLeft: 40,
                        paddingRight: 40,
                    },
                },
            },
            MuiButtonBase: {
                root: {
                    fontFamily: fontFamilySet,
                    fontWeight: FontWeights.Bold,
                    fontSize: '1.25rem',
                    '&$focusVisible': {
                        outline: 'revert',
                    },
                },
            },
            MuiButton: {
                root: {
                    textTransform: 'none',
                    fontSize: '1rem',
                    fontWeight: FontWeights.Bold,
                    letterSpacing: 'normal',
                    paddingLeft: 24,
                    paddingRight: 24,
                    borderRadius: 5,
                    minWidth: 144,
                },
                contained: {
                    boxShadow: 'none',
                    '&$focusVisible': {
                        boxShadow: 'none',
                    },
                    '&:active': {
                        boxShadow: 'none',
                    },
                    '&:hover': {
                        boxShadow: 'none',
                        color: Colors.SecondaryText,
                    },
                    '&$disabled': {
                        backgroundColor: Colors.Grey500,
                        color: Colors.SecondaryText,
                    },
                },
                outlined: {
                    '&$disabled': {
                        color: Colors.Grey500,
                        borderColor: Colors.Grey500,
                    },
                },
                text: {
                    color: Colors.PrimaryMain,
                    '&:hover': {
                        color: Colors.PrimaryDark,
                        backgroundColor: 'transparent',
                    },
                    '&:focus': {
                        color: Colors.PrimaryDark,
                    },
                },
                textPrimary: {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
                textSecondary: {
                    '&:hover': {
                        color: Colors.SecondaryDark,
                        backgroundColor: 'transparent',
                    },
                },
                outlinedPrimary: {
                    backgroundColor: Colors.White,
                    borderColor: Colors.PrimaryMain,
                    '&:hover': {
                        backgroundColor: Colors.White,
                        borderColor: Colors.PrimaryDark,
                        color: Colors.PrimaryDark,
                    },
                },
                containedPrimary: {
                    '&$focusVisible': {
                        boxShadow: '0 0 6px 0 rgba(15, 105, 175, 0.5), inset 0 0 0 2px #ffffff',
                    },
                },
                containedSecondary: {
                    color: Colors.SecondaryText,
                    '&$focusVisible': {
                        boxShadow: `0 0 6px 0 rgba(80, 50, 145, 0.5), inset 0 0 0 2px #ffffff`,
                    },
                },
                outlinedSecondary: {
                    '&:hover': {
                        backgroundColor: 'transparent',
                        borderColor: Colors.SecondaryDark,
                        color: Colors.SecondaryDark,
                    },
                    '&$disabled': {
                        borderColor: Colors.Grey500,
                    },
                },
                sizeLarge: {
                    fontSize: '1rem',
                    padding: '10px 24px',
                    '&$outlinedSizeLarge': {
                        padding: '9px 24px',
                        [breakpoints.up('md')]: {
                            padding: '5px 24px',
                        },
                    },
                },
            },
            MuiSvgIcon: {
                root: {
                    fontSize: '1.25rem',
                },
                colorDisabled: {
                    color: Colors.Grey500,
                },
            },
            MuiCheckbox: {
                root: {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&$checked': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
                colorPrimary: {
                    '&$checked': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
                colorSecondary: {
                    '&$checked': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
            },
            MuiChip: {
                colorSecondary: {
                    backgroundColor: 'rgba(6, 170, 102, 0.1)',
                    color: Colors.Grey800,
                    fontWeight: FontWeights.Bold,
                },
            },
            MuiMenuItem: {
                root: {
                    '&:hover': {
                        backgroundColor: Colors.PrimaryLight,
                    },
                    '&$selected, &$selected:hover': {
                        backgroundColor: Colors.PrimaryLight,
                    },
                },
            },
            MuiSwitch: {
                switchBase: {
                    color: Colors.Grey50,
                },
            },
        },
        mixins: exports.mixins,
    };
    return (0, styles_1.createTheme)(themeConfig);
};
exports.loadTheme = loadTheme;
//# sourceMappingURL=index.js.map